<template>
  <div class="container">
    <!-- <div class="haierlogo">
        <img width="100%" src="@/assets/icon/icon_haibei.png" alt="">
    </div> -->
    <div class="search" @click="search()">
      <img class="haier" src="@/assets/icon/search.png" alt="" />
      <input type="text" placeholder="请输入商品名称..." />
    </div>
    <div class="shop" @click="gocard">
      <van-icon name="shopping-cart-o" size="26px" />
    </div>
    <template v-if="isRefresh">
      <div class="login">
        <div @click="goMyPage()">
          <img class="portrait" :src="headurl" alt="" />
        </div>
        <div class="titie">
          <span class="count">个人中心</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { totalPoint, getUserInfo } from "@/api/api";
export default {
  components: {},
  props: ["cmsData"],
  inject: ["obj"],
  data() {
    return {
      createTime: "",
      username: "",
      totalPoint: "",
      headurl: "",
      isRefresh: true,
    };
  },
  watch: {
    "obj.initDeviceDone": {
      handler(newBool) {
        if (newBool) {
          this.upperFindTotalPoint();
          this.getUserInfo();
        }
      },
    },
  },
  computed: {},
  methods: {
    gocard() {
      this.$router.push({
        path: "/ShoppingCart",
      });
    },
    async upperFindTotalPoint() {
      //获取总积分
      let totalRes = await totalPoint();
      if (totalRes.code == "0000") {
        this.totalPoint = totalRes.data;
      }
    },
    goMyPage() {
      this.$router.push({
        path: "/my",
      });
    },
    search() {
      console.log("12152121");
      this.$router.push({
        path: "/orders/search",
      });
    },
    //用户头像
    async getUserInfo() {
      let userInfo = await getUserInfo();
      if (userInfo && userInfo.data) {
        this.isRefresh = false;
        this.username = userInfo.data.username;
        this.headurl = userInfo.data.headurl;
        this.$nextTick(() => {
          this.isRefresh = true;
        });
      }
    },
  },
  created() {
    this.upperFindTotalPoint();
    this.getUserInfo();
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  align-items: center;
  background: #004ea1;
}

.haierlogo,
.search,
.login {
  flex-flow: 1;
}

.haier {
  width: 36px;
  height: 36px;
  margin-right: 20px;
}

.haierlogo {
  width: 60%;
  padding-left: 20px;
}

.search {
  width: 64%;
  height: 55px;
  border-radius: 36px;
  background-color: #fff;
  margin-left: 20px;
  display: flex;
  align-items: center;
  padding-left: 20px;

  input {
    border: none;
    width: 60%;
    font-size: 20px;
  }
}

.login {
  margin-right: 20px;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-left: 20px;

  .titie {
    font-size: 25px;
    color: #fff;

    .count {
      color: #dc9f2e;
      padding-right: 5px;
      font-size: 25px;
    }
  }

  .portrait {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
}
.shop {
  color: #fff;
  padding-left: 20px;
}
</style>
